import { DatasetItem } from '../../../types/types';

/** First of the candidate names that the definition actually declares. */
export const findFirstItemName = (
  items: DatasetItem[],
  candidates: string[]
): string | undefined =>
  candidates.find((candidate) =>
    items.some((item) => item.name === candidate)
  );
